var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tiles-grid', { 'tiles-grid--icon': _vm.iconGrid }]},[(_vm.iconGrid)?_c('div',{staticClass:"tiles-grid__icons"},[_vm._t("default")],2):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }